import { useGetCharacteristicsGroupsQuery } from '../../api';
import { CharacteristicGroupSelectUI } from './CharacteristicGroupSelectUI';
import { type CharacteristicGroupSelectProps } from './types';

export const CharacteristicGroupSelect = (props: CharacteristicGroupSelectProps) => {
    const { data } = useGetCharacteristicsGroupsQuery({});

    return <CharacteristicGroupSelectUI groups={data?.groups} {...props} />;
};
